export default "__VITE_ASSET__Dxo0dFkA__"